import React from 'react';
import AIBusinessAssessmentEnhanced from './AIBusinessAssessmentEnhanced';

function App() {
  return (
    <div className="App">
      <AIBusinessAssessmentEnhanced />
    </div>
  );
}

export default App;
